require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2007-12-21-22-23.json") })
        }
      }, "path---articles-2007-12-21-22-23");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2007-12-21-22-23!./.cache/json/articles-2007-12-21-22-23.json
// module id = 541
// module chunks = 231608221292675